// src/utils/cn.ts
// Petit utilitaire pour composer des classNames conditionnels sans dépendance
// supplémentaire (équivalent minimal de `clsx`).

export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | Record<string, boolean | undefined | null>
  | ClassValue[];

export function cn(...values: ClassValue[]): string {
  const out: string[] = [];

  const push = (value: ClassValue) => {
    if (!value && value !== 0) return;
    if (typeof value === "string" || typeof value === "number") {
      out.push(String(value));
    } else if (Array.isArray(value)) {
      value.forEach(push);
    } else if (typeof value === "object") {
      Object.entries(value).forEach(([key, enabled]) => {
        if (enabled) out.push(key);
      });
    }
  };

  values.forEach(push);
  return out.join(" ");
}
